import request from '@/services/request'
import { IUserPermission } from '@/types/user'
import { useQuery } from '@tanstack/react-query'

export const useGetPermissions = () => {
  const fetchPermissions = async (): Promise<IUserPermission[]> => {
    const response = await request.private.get(
      'users/v2/permissions/my-permissions/'
    )
    return response.data
  }
  return useQuery<IUserPermission[]>({
    queryKey: ['user-permissions'],
    queryFn: fetchPermissions,
  })
}
